import { useState } from "react";
import axios from "../../api/axiosInstance";
import Header from "../PublicHeader";
import Footer from "../Footer";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { castIcon } from "../../utils/castIcon";

const EnvelopeIcon = castIcon(FaEnvelopeOpenText);

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setMessage("");
        setError("");

        try {
            const res = await axios.post<{ message: string }>("/api/request-password-reset", { email });
            setMessage(res.data.message);
        } catch (err: any) {
            setError(err.response?.data?.error || "Something went wrong.");
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-blue-100">
            <Header />
            <main className="flex-grow flex items-center justify-center px-4 py-12">
                <div className="w-full max-w-lg bg-white shadow-xl rounded-xl p-8 sm:p-10 animate-fade-in-up">
                    <div className="text-center mb-6">
                        <div className="flex justify-center mb-4">
                            <EnvelopeIcon className="text-blue-600 text-4xl" />
                        </div>
                        <h2 className="text-3xl font-extrabold text-gray-800">Forgot Your Password?</h2>
                        <p className="text-gray-500 mt-1 text-sm">
                            Enter your registered email address and we’ll send you a reset link.
                        </p>
                    </div>

                    {message && (
                        <div className="bg-green-50 text-green-700 border border-green-200 px-4 py-2 rounded mb-4 text-center text-sm font-medium">
                            {message}
                        </div>
                    )}
                    {error && (
                        <div className="bg-red-50 text-red-700 border border-red-200 px-4 py-2 rounded mb-4 text-center text-sm font-medium">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Email address</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="you@example.com"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition duration-300"
                        >
                            📩 Send Reset Link
                        </button>
                    </form>

                    <p className="mt-6 text-sm text-gray-500 text-center">
                        Remembered your password?{" "}
                        <a href="/login" className="text-blue-600 font-medium hover:underline">
                            Go back to login
                        </a>
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
}
